/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useAuth } from '../../hooks/useAuth'

const KVersionApp: FC = () => {
  const { user } = useAuth()
  return (
    <div>
      Versión: {user.versionAplicacion}
    </div>
  )
}

export { KVersionApp }
